import { Navigate } from "react-router-dom";
import { hasValidToken } from "@shared/lib/auth/tokenUtils";

export default function PublicRoute({ children }) {
  return hasValidToken() ? <Navigate to="/main" replace /> : children;
}
